export default {
  nav: {
    home: "Inicio", casa: "La Casa", camere: "Habitaciones", gallery: "Galería",
    dove: "Ubicación", cosa: "Qué Ver", esperienze: "Experiencias",
    recensioni: "Reseñas", contatti: "Contacto", prenota: "Reservar",
  },
  hero: {
    eyebrow: "Casa Vacanze Margherita · Santa Croce Camerina, Sicilia",
    lines: ["Tu casa en Sicilia,", "entre mar, cultura", "y libertad."],
    sub: "Vive el sureste de Sicilia alojándote en Casa Vacanze Margherita: tu punto de partida ideal para descubrir el mar, los pueblos barrocos y las maravillas de la costa.",
    cta1: "Descubre la casa",
    cta2: "Comprobar disponibilidad",
    badges: ["3 habitaciones", "Hasta 6 huéspedes", "Wi-Fi rápido", "Aire acondicionado", "3 balcones", "Check-in autónomo"],
    scroll: "Desliza para descubrir",
  },
  welcome: {
    eyebrow: "Bienvenidos",
    title: "Bienvenidos a Casa Vacanze Margherita",
    p1: "Abre la puerta, deja las maletas y empieza a descubrir Sicilia. El mar está a pocos minutos, y algunos de los pueblos barrocos más bonitos de la isla te esperan un poco más adelante.",
    p2: "Un apartamento de 110 m² en la segunda planta de un edificio tranquilo: tres habitaciones, una cocina que huele a limones, un salón para las tardes lentas y tres balcones para respirar el aire del sur.",
    stats: [{ v: "110", l: "m² de casa" }, { v: "3", l: "habitaciones" }, { v: "6", l: "huéspedes máx" }, { v: "3", l: "balcones" }],
  },
  comfort: {
    eyebrow: "Las Comodidades",
    title: "Cada detalle, pensado para tus vacaciones",
    items: [
      { icon: "ChefHat", t: "La cocina de las comidas largas", d: "Equipada y luminosa, con todo lo necesario para cocinar juntos los productos del mercado — y un balcón a dos pasos de la mesa." },
      { icon: "Tv", t: "Noches de películas y series", d: "Dos Smart TV con Netflix para las noches en las que solo quieres tumbarte en el sofá y recargar energías para el día siguiente." },
      { icon: "Snowflake", t: "El frescor cuando hace falta", d: "Aire acondicionado para dormir bien incluso en las noches de agosto, cuando Sicilia no deja de brillar." },
      { icon: "WashingMachine", t: "Maletas más ligeras", d: "Lavadora a tu disposición: viaja con menos equipaje y quédate un día más, si quieres." },
      { icon: "Armchair", t: "Tres balcones, tres momentos", d: "El café de la mañana, el libro de la tarde, el aperitivo al atardecer. Cada balcón tiene su hora perfecta." },
      { icon: "KeyRound", t: "Llega cuando quieras", d: "Check-in autónomo e inteligente: sin horarios rígidos, sin esperas. El viaje es tuyo, la casa te espera." },
      { icon: "Car", t: "Aparcamiento cercano", d: "Aparca cómodamente a pocos pasos de casa y olvídate del coche hasta la próxima exploración." },
      { icon: "PawPrint", t: "Tus mascotas son bienvenidas", d: "Perros y gatos viajan contigo y aquí están como en casa. Ellos también merecen unas vacaciones." },
      { icon: "Gift", t: "Una bienvenida que huele a Sicilia", d: "Te espera un pequeño regalo artesanal: nuestra manera de decirte que aquí eres de la familia." },
    ],
  },
  seaCulture: {
    eyebrow: "From Sea to Culture",
    title: "Dos mundos, una sola casa",
    motto: "Por la mañana el mar. Por la tarde un pueblo barroco. Por la noche una cena siciliana.",
    sea: { label: "SEA", title: "El mar a pocos minutos", text: "Playas doradas, atardeceres en el paseo marítimo y el faro de Punta Secca que vigila la casa de Montalbano.", points: ["Marina di Ragusa", "Punta Secca", "Donnalucata"] },
    culture: { label: "CULTURE", title: "El barroco a la vuelta de la esquina", text: "Piedra dorada, escalinatas escenográficas, chocolate y tradiciones: el Val di Noto es Patrimonio de la UNESCO.", points: ["Scicli", "Modica", "Ragusa Ibla", "Noto"] },
    cta: "Explora el territorio",
  },
  roomsTeaser: {
    eyebrow: "Las Habitaciones",
    title: "Tres habitaciones, cada una con su carácter",
    text: "No habitaciones de hotel, sino verdaderas estancias de una casa de verdad: luminosas, silenciosas, listas para tu descanso.",
    cta: "Descubre las habitaciones",
  },
  rooms: {
    matrimoniale: { name: "Habitación Doble", beds: "Cama de matrimonio · 2 plazas", d: "Amplia y luminosa, con balcón, gran armario con espejo y el silencio justo para dormir de verdad.", features: ["Balcón privado", "Aire acondicionado", "Armario con espejo"] },
    singola: { name: "Habitación Individual", beds: "Cama individual · 1 plaza", d: "Un refugio tranquilo y acogedor, perfecto para quien viaja en familia pero ama su propio espacio.", features: ["Luminosa y silenciosa", "Ideal para adolescentes"] },
    castello: { name: "Habitación con Litera", beds: "Litera · 2 plazas", d: "A los niños les encanta, los amigos la aprecian: dos plazas, aire acondicionado y balcón.", features: ["Balcón", "Aire acondicionado", "Perfecta para los más pequeños"] },
  },
  position: {
    eyebrow: "La Ubicación",
    title: "Entre el mar y la Sicilia que quieres descubrir.",
    text: "Casa Vacanze Margherita está en Santa Croce Camerina: llegas al mar en pocos minutos y desde aquí cada día puede tener una dirección distinta — la costa, los pueblos, el barroco.",
    note: "Tiempos de trayecto orientativos en coche",
    min: "min aprox.",
    here: "Estás aquí",
    cta: "Mira dónde estamos",
  },
  destinations: {
    santacroce: { name: "Santa Croce Camerina", d: "Tu cuartel general: un pueblo auténtico, con mercados, hornos y la Sicilia de cada día." },
    puntasecca: { name: "Punta Secca", d: "La casa del Comisario Montalbano, el faro y una playa que parece un decorado de cine." },
    marina: { name: "Marina di Ragusa", d: "Paseo marítimo, puerto deportivo, restaurantes junto al mar y playas equipadas para toda la familia." },
    donnalucata: { name: "Donnalucata", d: "Un pueblo de pescadores con barcas de colores y mercado de pescado por la mañana." },
    scicli: { name: "Scicli", d: "Un salón barroco encajado entre canteras: palacios, iglesias y la calle más fotografiada del sureste." },
    modica: { name: "Modica", d: "La catedral de San Giorgio y el chocolate más antiguo de Italia, para degustar donde nació." },
    ragusa: { name: "Ragusa Ibla", d: "Un belén de piedra dorada: callejones, jardines y la catedral que domina el valle." },
    noto: { name: "Noto", d: "La capital del barroco siciliano: un corso de palacios dorados que se enciende al atardecer." },
  },
  experiences: {
    eyebrow: "Experiencias",
    title: "No te limites a alojarte. Vive Sicilia.",
    text: "Cada día puede ser distinto: te ayudamos nosotros a elegir, con los consejos de quien vive esta tierra.",
    more: "Descubre todas las experiencias",
    items: [
      { id: "mare", t: "Mar", d: "Playas libres y equipadas, calas y atardeceres en el paseo marítimo." },
      { id: "barocco", t: "Barroco", d: "Scicli, Modica, Ragusa Ibla, Noto: la Sicilia Patrimonio de la UNESCO." },
      { id: "enogastronomia", t: "Gastronomía", d: "Chocolate de Modica, granita para desayunar, pescado fresco para cenar." },
      { id: "borghi", t: "Pueblos", d: "Punta Secca, Donnalucata y los pueblos donde el tiempo se detiene." },
      { id: "famiglia", t: "Familia", d: "Playas seguras, espacios de verdad, juegos en casa: niños felices, padres relajados." },
      { id: "natura", t: "Naturaleza", d: "Campos de olivos y algarrobos, muros de piedra seca y reservas junto al mar." },
      { id: "relax", t: "Relax", d: "El balcón, un libro, el sol: las vacaciones más sencillas que existen." },
      { id: "cultura", t: "Cultura", d: "Cerámicas, fiestas de pueblo, museos y los escenarios de Montalbano." },
      { id: "escursioni", t: "Excursiones", d: "Senderismo costero, paseos a caballo y días en barco por la costa." },
    ],
  },
  audience: {
    eyebrow: "Perfecta Para",
    title: "Reconócete en tus vacaciones",
    items: [
      { id: "coppie", t: "Parejas", d: "Para una escapada romántica en Sicilia, entre atardeceres junto al mar y cenas en los pueblos." },
      { id: "famiglie", t: "Familias", d: "El espacio y la libertad de sentirse en casa: juegos, cocina y playas seguras." },
      { id: "gruppi", t: "Grupos de amigos", d: "Tres habitaciones y todos los espacios para vivir las vacaciones juntos." },
      { id: "viaggiatori", t: "Viajeros", d: "La base ideal para explorar el sureste de Sicilia, cada día en una dirección nueva." },
    ],
  },
  reviews: {
    eyebrow: "Reseñas",
    title: "Las palabras de nuestros huéspedes",
    scoreWord: "Excepcional",
    countText: "Basado en 10 reseñas verificadas",
    verified: "Huésped verificado",
    reviewsWord: "reseñas",
    mapsLink: "Ver todas en Google Maps",
    readAll: "Leer todas las reseñas en Booking.com",
    cats: { cleanliness: "Limpieza", comfort: "Confort", value: "Relación calidad/precio", staff: "Personal", facilities: "Instalaciones", location: "Ubicación" },
    cta: "Todas las reseñas",
  },
  direct: {
    eyebrow: "Reserva Directa",
    title: "Reservando directamente con nosotros",
    items: [
      { icon: "MessagesSquare", t: "Asistencia directa", d: "Hablas con quien te va a acoger, sin intermediarios." },
      { icon: "Smartphone", t: "Comunicación sencilla", d: "Un mensaje por WhatsApp y tienes la respuesta que buscas." },
      { icon: "MapPinned", t: "Consejos personalizados", d: "Playas, restaurantes y pueblos: te contamos los que amamos nosotros." },
      { icon: "CalendarCheck", t: "Máxima flexibilidad", d: "Fechas, horarios de llegada, necesidades especiales: lo hablamos juntos." },
    ],
    cta: "Pedir un presupuesto",
  },
  finalCta: {
    title: "Sicilia te espera.",
    text: "Trae contigo las ganas de descubrir. Del resto se ocupará Casa Vacanze Margherita.",
    cta: "Comprobar disponibilidad",
  },
  footer: {
    tagline: "Sicilia te espera.",
    explore: "Explorar",
    contacts: "Contacto",
    rights: "Todos los derechos reservados.",
    payoff: "From Sea to Culture",
  },
  form: {
    title: "Comprobar disponibilidad",
    subtitle: "Rellena el formulario: te responderemos lo antes posible con disponibilidad y presupuesto.",
    name: "Nombre y apellidos",
    email: "Email",
    phone: "Teléfono (opcional)",
    checkin: "Llegada",
    checkout: "Salida",
    guests: "Huéspedes",
    pets: "Viajo con mascotas",
    message: "Mensaje",
    messagePh: "Cuéntanos algo de tu viaje...",
    submit: "Enviar solicitud",
    sending: "Enviando...",
    success: "¡Solicitud enviada! Te responderemos lo antes posible.",
    error: "Algo ha ido mal. Inténtalo de nuevo o escríbenos por WhatsApp.",
    whatsapp: "Continuar en WhatsApp",
    waMsg: "Hola, me gustaría recibir información sobre Casa Vacanze Margherita para una estancia",
  },
  contact: {
    title: "Contacto",
    heroTitle: "¿Necesitas información?",
    heroSub: "Escríbenos directamente: respondemos personalmente a cada mensaje.",
    whatsapp: "WhatsApp",
    phone: "Teléfono",
    email: "Email",
    where: "Dónde estamos",
    formTitle: "Escríbenos",
    send: "Enviar mensaje",
    success: "¡Mensaje enviado! Te responderemos pronto.",
  },
  pages: {
    casa: { eyebrow: "La Casa", title: "Una auténtica casa siciliana, lista para acogerte", seo: "La Casa | Casa Vacanze Margherita", desc: "Descubre el apartamento de 110 m²: 3 habitaciones, cocina equipada, salón con Smart TV, 3 balcones y todas las comodidades para tus vacaciones en Sicilia." },
    camere: { eyebrow: "Las Habitaciones", title: "Habitaciones de verdad, para descansos de verdad", seo: "Habitaciones | Casa Vacanze Margherita", desc: "Tres habitaciones luminosas para hasta 6 huéspedes: doble, individual y con litera. Casa de vacaciones en Santa Croce Camerina, Ragusa." },
    gallery: { eyebrow: "Galería", title: "Mira la casa, imagina las vacaciones", seo: "Galería | Casa Vacanze Margherita", desc: "Las fotografías reales de Casa Vacanze Margherita: habitaciones, cocina, espacios, detalles y el territorio del sureste de Sicilia." },
    dove: { eyebrow: "Ubicación", title: "Entre el mar y la Sicilia que quieres descubrir.", seo: "Ubicación | Casa Vacanze Margherita — Santa Croce Camerina", desc: "Casa Vacanze Margherita está en Santa Croce Camerina (RG): a pocos minutos de Marina di Ragusa y Punta Secca, base ideal para Scicli, Modica, Ragusa Ibla y Noto." },
    cosa: { eyebrow: "Qué Ver", title: "El sureste de Sicilia, día a día", seo: "Qué Ver | Sureste de Sicilia | Casa Vacanze Margherita", desc: "Marina di Ragusa, Punta Secca, Scicli, Modica, Ragusa Ibla, Noto: qué ver cerca de Casa Vacanze Margherita, con tiempos de trayecto." },
    esperienze: { eyebrow: "Experiencias", title: "No te limites a alojarte. Vive Sicilia.", seo: "Experiencias en Sicilia | Casa Vacanze Margherita", desc: "Mar, barroco, gastronomía, pueblos y naturaleza: las experiencias que vivir durante tu estancia en Casa Vacanze Margherita." },
    recensioni: { eyebrow: "Reseñas", title: "Las palabras de nuestros huéspedes", seo: "Reseñas | Casa Vacanze Margherita", desc: "Lo que dicen los huéspedes de Casa Vacanze Margherita, casa de vacaciones en Santa Croce Camerina cerca de Marina di Ragusa." },
    prenota: { eyebrow: "Reservar", title: "Reserva tu estancia", seo: "Reservar | Casa Vacanze Margherita", desc: "Comprueba la disponibilidad de Casa Vacanze Margherita y reserva directamente tus vacaciones en Sicilia." },
  },
  casaPage: {
    p1: "En la segunda planta de un edificio tranquilo en el corazón de Santa Croce Camerina, Casa Vacanze Margherita es un apartamento de 110 m² pensado para quien busca una casa de verdad, no una habitación de hotel.",
    p2: "El estilo es moderno con toques vintage y detalles sicilianos: el mantel de limones, las baldosas decoradas, una mandala dibujada a mano. Cada rincón cuenta el cuidado de quien ama esta casa.",
    petsTitle: "También tus amigos de cuatro patas",
    petsText: "Las mascotas son siempre bienvenidas: tráelas contigo, aquí encontrarán espacio y mimos.",
    giftTitle: "Bienvenido a casa",
    giftText: "A tu llegada encontrarás un pequeño regalo artesanal que huele a Sicilia: nuestra manera de darte la bienvenida.",
    faqTitle: "Preguntas frecuentes",
    faq: [
      { q: "¿Cómo puedo reservar?", a: "Directamente desde la web con el formulario de solicitud, o escribiéndonos por WhatsApp, email o teléfono. Te responderemos con disponibilidad y presupuesto." },
      { q: "¿Cuántas personas aloja la casa?", a: "El apartamento aloja cómodamente hasta 6 personas: perfecto para familias, parejas y grupos de amigos." },
      { q: "¿Se admiten mascotas?", a: "Sí, tus amigos de cuatro patas son siempre bienvenidos." },
      { q: "¿Cómo funciona el check-in?", a: "Con el check-in autónomo llegas a la hora que prefieras, sin limitaciones de horario." },
    ],
  },
  dovePage: {
    howTitle: "Cómo llegar",
    car: { t: "En coche", d: "Desde Catania sigue la A18 hacia Ragusa y continúa hasta Santa Croce Camerina (aprox. 1h45). Desde el aeropuerto de Comiso la casa está a unos 30 minutos." },
    plane: { t: "En avión", d: "Los aeropuertos más cercanos son Comiso (CIY) y Catania (CTA). Desde el aeropuerto puedes alquilar un coche o reservar un traslado privado." },
    bus: { t: "En autobús", d: "Desde Ragusa y Comiso salen autobuses directos a Santa Croce Camerina, con parada a pocos pasos de la casa." },
    quiet: "La casa está a pocos metros del centro histórico, en una zona tranquila y bien comunicada.",
  },
};
